import React from 'react';
import { SelectCustomField } from 'components/NewCustomFields/SelectCustomField';
import { useEleveGroups } from 'queries/eleveGroups/useEleveGroups';
import { useCreateEleveGroup } from 'queries/eleveGroups/useCreateEleveGroup';
import { useDeleteEleveGroup } from 'queries/eleveGroups/useDeleteEleveGroup';
import { useUpdateEleveGroup } from 'queries/eleveGroups/useUpdateEleveGroup';
import { EleveGroup } from 'types/eleveGroups';
import { isDefined } from 'types/utils';

interface Props {
  value: EleveGroup[];
  onChange: (value: EleveGroup[]) => void;
  className?: string;
  openOnMount?: boolean;
  onClickOutside?: (event: any) => void;
}

export function EleveGroupSelector({
  value,
  onChange,
  className,
  openOnMount,
  onClickOutside,
}: Props) {
  const { data: eleveGroups = [] } = useEleveGroups();
  const { mutateAsync: createEleveGroup } = useCreateEleveGroup();
  const { mutateAsync: deleteEleveGroup } = useDeleteEleveGroup();
  const { mutateAsync: updateEleveGroup } = useUpdateEleveGroup();

  return (
    <SelectCustomField
      name="groups"
      className={className}
      onClickOutside={onClickOutside}
      options={eleveGroups.map(group => ({
        id: group.id,
        value: group.name,
        color: group.color,
      }))}
      openOnMount={openOnMount}
      value={value.map(g => g.id)}
      allowMultipleValue
      onChange={v => {
        const selectedGroups = (v || [])
          ?.map(id => eleveGroups.find(g => g.id === id))
          .filter(isDefined);
        return onChange(selectedGroups);
      }}
      onUpdateOption={v =>
        updateEleveGroup({
          id: v.id,
          name: v.value,
          color: v.color,
        })
      }
      onRemoveOption={optionId => deleteEleveGroup(optionId)}
      onCreateOption={({ optionValue, color }) =>
        createEleveGroup({
          name: optionValue,
          color: color || 'gris-moderate',
          elevesIds: [],
        }).then(newGroup => onChange([...value, newGroup]))
      }
    />
  );
}
